import React from 'react';
import * as S from './seo-srp-carousel-ui.styles';
import ArrowLeftIcon from '../../../icons/ArrowLeft';
import ArrowRightIcon from '../../../icons/ArrowRight';

const SeoSrpCarouselUi = ({
  offer,
  onClickHandler,
  handleNextClick,
  handlePrevClick,
  isLeftCursorActive,
  isRightCursorActive
}) => {
  const { sub_heading, validity_text, image, img_url, url } = offer;
  return (
    <S.OfferWrap className="poRel">
      <S.OfferContainer className="flexCol">
        <S.CarouselOne className="dF">
          <S.CarouselContainer className="flexCol">
            <S.ImgSection className="flexCol" onClick={() => onClickHandler(url)}>
              <S.OfferImg loading="lazy" src={img_url || image.url} alt="Offer Image" />
            </S.ImgSection>
            <S.OfferContent className="flexCol">
              <S.OfferHeader className="padT10 padB10">{sub_heading}</S.OfferHeader>
              {validity_text && validity_text !== '' ? (
                <S.OfferValidity className="padT10 padB10 grey">
                  Valid till: {validity_text}
                </S.OfferValidity>
              ) : null}
              <S.ViewDetails className="flexCol padT10 alignItemsCenter">
                <S.BookButton onClick={() => onClickHandler(url)}>
                  <S.ButtonSpacing className="fn">View Details</S.ButtonSpacing>
                </S.BookButton>
              </S.ViewDetails>
            </S.OfferContent>
            <S.PrevNxtWrap className="alignSelfCenter dF">
              {isLeftCursorActive ? (
                <S.Prev onClick={handlePrevClick}>
                  <ArrowLeftIcon loading="lazy" />
                </S.Prev>
              ) : null}
              {isRightCursorActive ? (
                <S.Nxt onClick={handleNextClick}>
                  <ArrowRightIcon loading="lazy" />
                </S.Nxt>
              ) : null}
            </S.PrevNxtWrap>
          </S.CarouselContainer>
        </S.CarouselOne>
      </S.OfferContainer>
    </S.OfferWrap>
  );
};

export default SeoSrpCarouselUi;
